import React from 'react';
import { Row, Col, Avatar } from 'antd';
import { socmedTypeList } from '../../configs/socmedType';
import Wrapper from './style';
import { getNickName } from '../../utils/commonUtils';

const Index = (props) => {
  const { name, username, type = socmedTypeList[0].text, srcAvatar } = props;

  const socMedType = socmedTypeList.find((item) => {
    return item?.type === type;
  });

  return (
    <Wrapper>
      <div className="font-subtitle1_medium">
        Confirm your account connection to Alphaveritas
      </div>
      <div className="component_social_account_box">
        <Row gutter={[24, 24]}>
          <Col span={2}>
            {srcAvatar ? (
              <Avatar size={40} src={srcAvatar} />
            ) : (
              <Avatar size={40}>{getNickName(name)}</Avatar>
            )}
          </Col>
          <Col span={1} />
          <Col span={13} className="component_social_account_content">
            <div className="font-caption_medium">{name ?? '-'}</div>
            <div className="font-caption">{username ?? '-'}</div>
          </Col>
          <Col span={7}>
            <div className="component_social_account">
              {socMedType?.icon}
              <div className="font-paragraph">{socMedType?.label}</div>
            </div>
          </Col>
        </Row>
      </div>
      <p className="font-paragraph component_social_account_notes">
        AlphaVeritas needs permission to access and publish to
        {` ${socMedType.text} `}
        Account on your behalf. Please click “Accept” if you agree.
      </p>
    </Wrapper>
  );
};

export default Index;
